import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { STATE__images } from './STATE__images';

export const local_images_upsert_ai_description = (items: DTOImageAiDescription[]): PayloadAction<DTOImageAiDescription[]> => ({
  type: ENUM__redux_action.IMAGES_AI_DESCRIPTION_UPSERT,
  payload: items,
});

export const init_local_images_upsert_ai_description = (state: STATE__images, action: PayloadAction<DTOImageAiDescription[]>) => {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    state.ai_descriptions_map.set(item._id, item);
  }

  //refresh map to trigger re-render
  state.ai_descriptions_map = new Map(state.ai_descriptions_map);
};
